import React, { Component } from 'react';
// import ReactDOM from 'react-dom';
// import { Box } from 'reactjs-admin-lte'
import { Button, Modal } from 'react-bootstrap'
// import Select from 'react-select';
// import Moment, { defaultFormat } from 'moment';
import FontAwesome from 'react-fontawesome';
import IncentivePayeePage from './IncentivePayeePage'
// var NotificationSystem = require('react-notification-system');
const api = require('api')
const messages = api.getMessage().view.cashflow.IncentivePayeePageModal
class IncentivePayeePageModal extends Component {
  constructor(props) {
    super(props)

  }

  onHide() {
  	this.props.onHide()
  }

  render() {
  	return(
  	  <div>
  	  	<Modal show={this.props.show} onHide={this.onHide.bind(this)} dialogClassName="midwidth-dialog">
          <Modal.Header closeButton>
            <Modal.Title>{messages['Search Claim Employees']}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
          	<IncentivePayeePage
              ref={'incentivePayPage'}
              onSelectItem={this.props.onSelectItem}
          	/>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.onHide.bind(this)}><FontAwesome name='close' />&nbsp;{messages['Close']}</Button>
          </Modal.Footer>
        </Modal>
  	  </div>
  	)
  }
}    

export default IncentivePayeePageModal;


// WEBPACK FOOTER //
// ./src/view/cashflow/IncentivePayeePageModal.js